<script setup>
import { computed } from 'vue';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import FormSelect from 'v3/components/Form/Select.vue';

defineProps({
  label: { type: String, default: '' },
  description: { type: String, default: '' },
});

const { updateUISettings, uiSettings } = useUISettings();

const currentEmojiStyle = computed(
  () => uiSettings.value?.ai_emoji_style ?? 'static'
);

const emojiStyleOptions = computed(() => [
  {
    name: 'Estático',
    value: 'static',
  },
  {
    name: 'Animado',
    value: 'animated',
  },
]);

const updateEmojiStyle = async styleValue => {
  try {
    await updateUISettings({ ai_emoji_style: styleValue });
    useAlert('Estilo de emoji atualizado com sucesso');
  } catch (error) {
    useAlert('Erro ao atualizar o estilo do emoji');
    throw error;
  }
};

const selectedValue = computed({
  get: () => currentEmojiStyle.value,
  set: value => {
    updateEmojiStyle(value);
  },
});
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="ai_emoji_style"
      spacing="compact"
      class="min-w-28 mt-px"
      :options="emojiStyleOptions"
      label=""
    >
      <option
        v-for="option in emojiStyleOptions"
        :key="option.value"
        :value="option.value"
        :selected="option.value === selectedValue"
      >
        {{ option.name }}
      </option>
    </FormSelect>
  </div>
</template>
